import { CustomLabel, RecommendedFreeProduct } from '@mindmemobile/mm-shared-global';
import React from 'react'; 
import { CustomLine } from '../styles';
import { RelatedItemsCategoriesModel } from '../models';
import ImgPlaceholder from '../../../../../images/placeholders/no-image.svg';

type IProps = {
    includedItems?: RelatedItemsCategoriesModel[];
};

const FreeIncludedItems: React.FC<IProps> = ({ includedItems }) => {
    if (!includedItems || includedItems.length === 0) return null;
    return (
        <>
            <CustomLine width="100%" bgColor="#ccc" height="1px" />
            {includedItems.map((includedItem) => {
                const imageMedia = includedItem.medias.find((m) => m.isImage());
                return (
                    <RecommendedFreeProduct key={includedItem.id}>
                        {imageMedia ? (
                            <img src={imageMedia.fullURL} alt="image" />
                        ) : (
                            <img src={ImgPlaceholder} alt="image" />
                        )}
                        <CustomLabel>
                            Get a <span className="highlighted-black">Free </span>{' '}
                            <span className="semi-bold">{includedItem.name}</span> with purchase.
                        </CustomLabel>
                    </RecommendedFreeProduct>
                );
            })}
        </>
    );
};

export default FreeIncludedItems;
